import React from 'react';

import { NoContentWrapper } from 'src/components/NoContent';
import { useAppConfig } from 'src/config';

function HealthCheck() {
  const { appVersion } = useAppConfig();
  return (
    <NoContentWrapper
      height="100vh"
      title="Health-check page"
      subtitle={`Mgmt Portal v.${appVersion}`}
    />
  );
}

export default HealthCheck;
